import styled from 'styled-components/macro';
import * as RadixContextMenu from '@radix-ui/react-context-menu';
import {
  BaseCheckboxItem,
  BaseContent,
  BaseIndicator,
  BaseItem,
  BaseSeparator,
  BaseSubContent,
  BaseSubTrigger,
} from '../menu.styled';
import {
  menuSlideInBottom,
  menuSlideInLeft,
  menuSlideInRight,
  menuSlideInTop,
  menuSlideOutBottom,
  menuSlideOutLeft,
  menuSlideOutRight,
  menuSlideOutTop,
} from '../menu.animations';

export const StyledContent = styled(RadixContextMenu.Content)`
  ${BaseContent};
  max-width: var(--radix-context-menu-content-available-width);
  max-height: var(--radix-context-menu-content-available-height);
  transform-origin: var(--radix-context-menu-content-transform-origin);

  &[data-state='open'] {
    animation-name: ${menuSlideInBottom};
  }
`;

export const StyledSubTrigger = styled(RadixContextMenu.SubTrigger)`
  ${BaseSubTrigger};
`;

export const StyledSubContent = styled(RadixContextMenu.SubContent).attrs({
  sideOffset: 12,
  collisionPadding: 16,
})`
  ${BaseSubContent};
  max-width: var(--radix-context-menu-content-available-width);
  max-height: var(--radix-context-menu-content-available-height);
  transform-origin: var(--radix-context-menu-content-transform-origin);

  &[data-state='open'] {
    &[data-side='top'] {
      animation-name: ${menuSlideInTop};
    }
    &[data-side='right'] {
      animation-name: ${menuSlideInRight};
    }
    &[data-side='bottom'] {
      animation-name: ${menuSlideInBottom};
    }
    &[data-side='left'] {
      animation-name: ${menuSlideInLeft};
    }
  }

  &[data-state='closed'] {
    &[data-side='top'] {
      animation-name: ${menuSlideOutTop};
    }
    &[data-side='right'] {
      animation-name: ${menuSlideOutRight};
    }
    &[data-side='bottom'] {
      animation-name: ${menuSlideOutBottom};
    }
    &[data-side='left'] {
      animation-name: ${menuSlideOutLeft};
    }
  }
`;

export const StyledItem = styled(RadixContextMenu.Item)`
  ${BaseItem};
`;

export const StyledSeparator = styled(RadixContextMenu.Separator)`
  ${BaseSeparator};
`;

export const StyledCheckboxItem = styled(RadixContextMenu.CheckboxItem)`
  ${BaseCheckboxItem};
`;

export const StyledItemIndicator = styled(RadixContextMenu.ItemIndicator)`
  ${BaseIndicator};
`;
